
import api from "@/api";
import { Station } from "@/api/dtos/Station.schema";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DangerButton from "../buttons/DangerButton.vue";
import WarnButton from "../buttons/WarnButton.vue";
import DangerDialog from "../dialogs/DangerDialog.vue";
import WarnDialog from "../dialogs/WarnDialog.vue";
import EditFrame from "../EditFrame.vue";
import { StationsModule } from "@/store/modules/StationsModule";

import { showToast } from "@/utils/toastService";
import { getAxiosResponse } from "@/utils/errorUtils";
import EditButton from "../buttons/EditButton.vue";
import { User } from "@/api/dtos/User.schema";
import { UsersModule } from "@/store/modules/UsersModule";
import type { FirmwareVersion } from "@/api/dtos/FirmwareVersion.schema";
import type { FirmwareVersionOption } from "@/views/StationDetailsView.vue";

@Component({
  components: {
    EditFrame,
    EditButton,
    WarnButton,
    WarnDialog,
    DangerButton,
    DangerDialog,
  },
})
export default class BlockAndDeleteStation extends Vue {
  @Prop()
  station!: Station;
  @Prop({ required: true })
  firmwareversions!: FirmwareVersionOption[];

  showDeleteDialog = false;
  showBlockDialog = false;
  showRebootDialog = false;
  showFirmwareUpdateDialog = false;

  selectedFirmwareVersionId = null;

  isStationActive = false;

  @Watch("station.isActive")
  onStationActiveChanged(newValue: boolean): void {
    this.initializeWidget();
  }

  mounted(): void {
    this.initializeWidget();
  }

  get isAdmin(): boolean {
    return this.localUser?.isAdmin || false;
  }

  get localUser(): User | null {
    return UsersModule.localUser;
  }

  initializeWidget(): void {
    this.isStationActive = this.station.isActive;
  }

  async onConfirmBlockStation(): Promise<void> {
    const newState = !this.isStationActive;

    try {
      await api.StationsApi.updateIsStationActive(this.station.uuid, newState);
      this.isStationActive = newState;
      await StationsModule.refreshDetailedStation();

      if (newState) {
        showToast({
          message: "Station wurde entsperrt",
          type: "success",
        });
      } else {
        showToast({
          message: "Station wurde gesperrt",
          type: "success",
        });
      }
    } catch (e) {
      console.error("Station block error:", e);
      showToast({
        response: getAxiosResponse(e),
        message: "Status der Station konnte nicht geändert werden",
        type: "error",
      });
    }
  }

  async onConfirmDeleteStation(): Promise<void> {
    try {
      await api.StationsApi.deleteStation(this.station.uuid);
      showToast({
        message: "Station wurde gelöscht",
        type: "success",
      });
      this.$router.push({ name: "Stationen" });
    } catch (e) {
      console.error("Station delete error:", e);
      showToast({
        response: getAxiosResponse(e),
        message: "Station konnte nicht gelöscht werden",
        type: "error",
      });
    }
  }

  async onConfirmFirmwareUpdate(): Promise<void> {
    if(this.selectedFirmwareVersionId == null) return;
    const firmwareId = Number(this.selectedFirmwareVersionId);
    try {
      // const success = true;
      const success = await api.StationsApi.update(this.station.uuid,firmwareId);
      if (success)
        showToast({
          message: "Firmware update wird durchgeführt.",
          type: "success",
        });
      else
        showToast({
          message: "Firmware update konnte nicht gestartet werden.",
          type: "error",
        });
    } catch (e) {
      showToast({
        response: getAxiosResponse(e),
        message: "Firmware update konnte nicht gestartet werden.",
        type: "error",
      });
    }
  }
  
  async onConfirmReboot(): Promise<void> {
    try {
      const success = await api.StationsApi.reboot(this.station.uuid);
      if (success)
        showToast({
          message: "Station wird neu gestartet",
          type: "success",
        });
      else
        showToast({
          message: "Station konnte nicht neu gestartet werden",
          type: "error",
        });
    } catch (e) {
      showToast({
        response: getAxiosResponse(e),
        message: "Station konnte nicht neu gestartet werden",
        type: "error",
      });
    }
  }

  async retrieveControllerToken(): Promise<void> {
    try {
      const token = await api.StationsApi.getControllerToken(this.station.uuid);
      await navigator.clipboard.writeText(token);
      showToast({
        message: "Das Controller Token wurde in die Zwischenablage kopiert",
        type: "success",
      });
    } catch (e) {
      console.error("Station delete error:", e);
      showToast({
        response: getAxiosResponse(e),
        message: "Das Controller Token konnte nicht in die Zwischenablage kopiert werden",
        type: "error",
      });
    }
  }
}
